import { ClinicOSHero } from "@/components/landing/ClinicOSHero";
import { DisconnectedCost } from "@/components/landing/DisconnectedCost";
import { MeetClinicOS } from "@/components/landing/MeetClinicOS";
import { ClinicLifecycle } from "@/components/landing/ClinicLifecycle";
import { ClinicAudit } from "@/components/landing/ClinicAudit";
import { KaiSection } from "@/components/landing/KaiSection";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { SectionReveal } from "@/components/landing/SectionReveal";

/* Join Clinic OS — the original 7-section conversion narrative.
   Kept distinct from the new Home page so the long-form story is preserved
   for visitors who want the full Problem → Cost → Solution → Lifecycle → Audit → KAI → Close walk.
*/
export default function JoinClinicOS() {
  return (
    <>
      <ClinicOSHero />
      <SectionReveal><DisconnectedCost /></SectionReveal>
      <SectionReveal><MeetClinicOS /></SectionReveal>
      <SectionReveal><ClinicLifecycle /></SectionReveal>
      <SectionReveal><ClinicAudit /></SectionReveal>
      <SectionReveal><KaiSection /></SectionReveal>
      <SectionReveal><FinalCTA /></SectionReveal>
    </>
  );
}
